export { default } from "./Team";
